export default {"src":"/_next/static/media/zhaket-light-logo.ce3201e2.svg","height":63,"width":85,"blurWidth":0,"blurHeight":0};